export default function getTemplateType(isShowroom: boolean): string {
    const TEMPLATE_STANDALONE = 'standalone'
    const TEMPLATE_DEFAULT = 'default'

    return isShowroom ? TEMPLATE_STANDALONE : TEMPLATE_DEFAULT
}
